import { render, staticRenderFns } from "./connectFlowCard.vue?vue&type=template&id=12da4c27&"
import script from "./connectFlowCard.vue?vue&type=script&lang=js&"
export * from "./connectFlowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports